<template>
  <div id="artist-page" class="artist-profile" style="width:100%;">

    <div v-if="artist && (artist.backgroundURL||artist.profileURL)" class="background-header" v-bind:style="{ backgroundImage: 'url(' +(artist.backgroundURL||artist.profileURL) + ')' }"></div>
    <div v-else class="background-header"></div>

    <!-- <gallery :images="artistArtworkImages" :index="lightboxIndex" @close="lightboxIndex = null"></gallery> -->
    <gallery v-if="artist" :images="artist.gallery" :index="galleryLightboxIndex" @close="galleryLightboxIndex = null"></gallery>
    <v-container class="artist-profile-content" :class="{'cv-tab': shouldIncludeCVTab}" v-if="artist">
      <v-layout row wrap>

        <v-flex class="profile-overview pa-3" xs12 md4>
          <div class="content">
            <v-card style="width:100%;">
              <div class="">
                <v-card-media
                  :src="artist.profileURL || placeHolderArtistImg"
                  height="350px"
                >
                </v-card-media>
                <v-btn v-if="false" class="follow-artist" @click.native="">
                  Follow Artist
                </v-btn>
              </div>
              <v-card-title primary-title class="pt-1 pb-1">
                <v-flex class="breadcrumbs-wrap hidden-md-and-up clearfix" xs12>

                  <v-breadcrumbs class="ma-0 pa-0">
                    <v-icon slot="divider">chevron_right</v-icon>
                    <v-breadcrumbs-item
                      v-for="item in breadcrumbs" :key="item.text"
                      :disabled="item.disabled"
                      :to="item.href"
                    >
                      {{ item.text }}
                    </v-breadcrumbs-item>
                  </v-breadcrumbs>
                </v-flex>

                <v-flex xs12>
                  <div class="headline">About {{artist.firstName}}</div>
                  <p>{{artist.city}}</p>
                  <span v-if="artist.tagline" class="grey--text">{{artist.tagline}}</span>
                </v-flex>
              </v-card-title>

              <v-slide-y-transition>
                <v-card-text v-if="artist.excerpt">
                  <div>{{artist.excerpt}}</div>
                </v-card-text>
              </v-slide-y-transition>

              <ul class="social-menu">
                <li v-if="artist.facebook">
                  <v-layout row wrap>
                    <v-flex xs2 class="text-xs-right">
                      <span><v-icon>fa-facebook</v-icon></span>
                    </v-flex>
                    <v-flex xs10>
                      <a :href="facebookURL(artist.facebook)" target="_blank">{{artist.facebook}}</a>
                    </v-flex>
                  </v-layout>
                </li>

                <li v-if="artist.instagram">
                  <v-layout row wrap>
                    <v-flex xs2 class="text-xs-right">
                      <span><v-icon>fa-instagram</v-icon></span>
                    </v-flex>
                    <v-flex xs10>
                      <a :href="instagramURL(artist.instagram)" target="_blank">{{artist.instagram}}</a>
                    </v-flex>
                  </v-layout>
                </li>

                <li v-if="artist.twitter">
                  <v-layout row wrap>
                    <v-flex xs2 class="text-xs-right">
                      <span><v-icon>fa-twitter</v-icon></span>
                    </v-flex>
                    <v-flex xs10>
                      <a :href="twitterURL(artist.twitter)" target="_blank">{{artist.twitter}}</a>
                    </v-flex>
                  </v-layout>
                </li>

                <li v-if="artist.pinterest">
                  <v-layout row wrap>
                    <v-flex xs2 class="text-xs-right">
                      <span><v-icon>fa-pinterest</v-icon></span>
                    </v-flex>
                    <v-flex xs10>
                      <a :href="pinterestURL(artist.pinterest)" target="_blank">{{artist.pinterest}}</a>
                    </v-flex>
                  </v-layout>
                </li>

                <li v-if="artist.website">
                  <v-layout row wrap>
                    <v-flex xs2 class="text-xs-right">
                      <span><v-icon>fa-id-card-o</v-icon></span>
                    </v-flex>
                    <v-flex xs10>
                      <a :href="websiteURL(artist.website)" target="_blank">{{artist.website}}</a>
                    </v-flex>
                  </v-layout>
                </li>

                <li v-if="artist.email && artist.showEmail">
                  <v-layout row wrap>
                    <v-flex xs2 class="text-xs-right">
                      <span><v-icon>fa-envelope-open</v-icon></span>
                    </v-flex>
                    <v-flex xs10>
                      <a :href="'mailto:' + artist.email" target="_blank">{{artist.email}}</a>
                    </v-flex>
                  </v-layout>
                </li>
              </ul>

            </v-card>
          </div>
        </v-flex>

        <v-flex class="profile-body pa-3" xs12 md8 v-if="activeTab">

          <v-toolbar color="white darken-1" dark tabs>
            <v-toolbar-title>
              <div class="breadcrumbs-wrap hidden-sm-and-down">

                <v-breadcrumbs class="ma-0 pa-0">
                  <v-icon slot="divider" :style="{color:themeColor}">chevron_right</v-icon>
                  <v-breadcrumbs-item
                    v-for="item in breadcrumbs" :key="item.text"
                    :disabled="item.disabled"
                    :to="item.href"
                  >
                    {{ item.text }}
                  </v-breadcrumbs-item>
                </v-breadcrumbs>
              </div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <router-link
              v-if="enableEditArtistLink && this.$route.params.id"
              tag="button"
              class="btn btn--raised pa-2"
              :to="{ name: 'EditArtist', params: { id: this.$route.params.id } }">
            Edit Profile</router-link>

            <v-tabs
              centered
              color="grey darken-1"
              slot="extension"
              v-model="activeTab"
            >
              <v-tab
                :href="`#tab-${tab.name}`"
                :key="tab.name"
                v-for="tab in tabs"
              >
                <v-icon>{{tab.icon}}</v-icon>
                <span class="tab-title">&nbsp;{{ tab.name }}</span>
              </v-tab>
            </v-tabs>
          </v-toolbar>

          <v-tabs-items v-model="activeTab">
            <v-tab-item
              v-for="(tab, key) in tabs"
              :key="tab.name"
              :id="`tab-${tab.name}`"
            >

              <!-- INSERT HERE -->

              <v-card flex flat v-if="tab.name === 'artworks'" class="pa-3">
                <v-layout row wrap class="content">
                  <v-flex xs12 v-if="artworkMarkers && artworkMarkers.length > 0">
                    <gmap-map
                      ref="artworksMap"
                      :center="mapCenter"
                      :zoom="15"
                      map-type-id="terrain"
                      style="width: 100%; height: 300px"
                    >

                      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                        <div class="artwork-info-window">
                          <img :src="infoImage | thumbnailURL" width="90" alt="" />
                          <p>{{infoContent}}</p>
                        </div>
                      </gmap-info-window>

                      <gmap-cluster>
                        <gmap-marker
                          :key="i"
                          v-for="(m, i) in artworkMarkers"
                          :position="m.position"
                          :icon="m.icon"
                          :clickable="true"
                          @click="toggleInfoWindow(m,i)"
                        ></gmap-marker>
                      </gmap-cluster>
                    </gmap-map>
                  </v-flex>

                  <v-flex xs12>
                    <v-container fluid v-bind="{ [`grid-list-lg`]: true }">
                      <v-layout row wrap>
                        <v-flex
                          xs4
                          v-for="artwork, imageIndex in artistArtworks"
                          :key="artwork['.key']"
                        >
                          <v-card flat tile>
                            <!-- <a :href="artwork.cloudinaryImageURL" target="_blank"> -->
                            <a @click="lightboxIndex = imageIndex">
                              <!-- <lazy-component> -->
                                <v-card-media
                                  v-if="artwork.cloudinaryImageURL"
                                  :src="artwork.cloudinaryImageURL | thumbnailURL"
                                  height="150px"
                                >
                                </v-card-media>
                              <!-- </lazy-component> -->
                            </a>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>

                </v-layout>
              </v-card>

              <v-card flex flat v-if="tab.name === 'about'" class="pa-3">
                <v-layout row wrap class="content pa-3">
                  <v-flex xs12>
                    <div v-if="artist.bio" class="about text-content" v-html="artist.bioHTML"></div>
                    <div v-else class="about text-content empty">
                      <p></p>
                      <p></p>
                      <p></p>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>

              <v-card flex flat v-if="tab.name === 'gallery'" class="pa-3">
                <v-layout row wrap class="content pa-3">

                  <v-flex xs12>
                    <v-container fluid v-bind="{ [`grid-list-lg`]: true }">
                      <v-layout row wrap>
                        <v-flex
                          xs12 md4
                          v-for="image, idx in artist.gallery"
                          :key="idx"
                        >
                          <v-card flat tile>
                            <!-- <a :href="artwork.cloudinaryImageURL" target="_blank"> -->
                            <a href @click.prevent="galleryLightboxIndex = idx">
                              <!-- <lazy-component> -->
                                <v-card-media
                                  v-if="image"
                                  :src="image | thumbnailURL"
                                  height="150px"
                                >
                                </v-card-media>
                              <!-- </lazy-component> -->
                            </a>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>

                </v-layout>
              </v-card>

              <v-card flex flat v-if="tab.name === 'cv'" class="pa-3">

                <div  v-if="artist.exhibitions && artist.exhibitions.length">
                  <v-flex xs12>
                    <span class="pt-5 headline">Exhibitions</span>
                    <p>Galleries, museums, or festivals exhibits with their work.</p>
                  </v-flex>

                  <v-layout row wrap class="portfolio-exhibitions cv-content">
                    <v-list three-line>
                      <template v-for="(item, idx) in artist.exhibitions">
                        <v-list-tile v-bind:key="item.title">
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <a v-if="item.url" :href="item.url" target="_blank">
                                {{item.name ? item.name : item.url}}
                              </a>
                              <span v-else>{{item.name ? item.name : item.url}}</span>
                            </v-list-tile-title>
                            <v-list-tile-title>{{item.address}}</v-list-tile-title>
                              <div>
                                <span>{{item.startDate | moment("ddd MMM D, YYYY")}}</span>
                                <span v-if="item.endDate">- {{item.endDate | moment("ddd MMM D, YYYY")}}</span>
                              </div>
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-layout>
                </div>

                <div v-if="artist.podcasts && artist.podcasts.length">
                  <v-flex xs12 class="mt-5">
                    <span class="pt-5 headline">Podcast</span>
                    <p>Podcasts in which they where featured in.</p>
                  </v-flex>

                  <v-layout row wrap class="portfolio-exhibitions cv-content">
                    <v-list two-line v-if="artist.podcasts && artist.podcasts.length">
                      <template v-for="(item, idx) in artist.podcasts">
                        <v-list-tile v-bind:key="idx">
                          <v-list-tile-content>
                            <v-list-tile-title>{{item.show}}</v-list-tile-title>
                            <v-list-tile-sub-title>
                              <a :href="item.url" target="_blank">{{item.url}}</a>
                            </v-list-tile-sub-title>
                            <v-list-tile-title class="pb-2">{{item.date | moment("ddd MMM D, YYYY")}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-layout>
                </div>

                <div v-if="artist.videos && artist.videos.length">
                  <v-flex xs12 class="mt-5">
                    <span class="pt-5 headline">Videos</span>
                    <p>Videos in which they where featured in.</p>
                  </v-flex>

                  <v-layout row wrap class="portfolio-exhibitions cv-content">
                    <v-list two-line>
                      <template v-for="(item, idx) in artist.videos">
                        <v-list-tile v-bind:key="idx">
                          <v-list-tile-content>
                            <v-list-tile-title>{{item.name}}</v-list-tile-title>
                            <v-list-tile-sub-title>
                              <a :href="item.url" target="_blank">{{item.url}}</a>
                            </v-list-tile-sub-title>
                            <v-list-tile-title class="pb-2">{{item.date | moment("ddd MMM D, YYYY")}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-layout>
                </div>

                <div v-if="artist.printBlogs && artist.printBlogs.length">
                  <v-flex xs12 class="mt-5">
                    <span class="pt-5 headline">Print/Blog Mentions</span>
                    <p>Magazines or blogs in which they where mentioned in.</p>
                  </v-flex>

                  <v-layout row wrap class="portfolio-exhibitions cv-content">
                    <v-list two-line>
                      <template v-for="(item, idx) in artist.printBlogs">
                        <v-list-tile v-bind:key="idx">
                          <v-list-tile-content>
                            <v-list-tile-title>{{item.name}}</v-list-tile-title>
                            <v-list-tile-sub-title>
                              <a :href="item.url" target="_blank">{{item.url}}</a>
                            </v-list-tile-sub-title>
                            <v-list-tile-title class="pb-2">{{item.date | moment("ddd MMM D, YYYY")}}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-layout>
                </div>

              </v-card>

              <v-card row wrap class="content" v-if="tab.name === 'store'">

              </v-card>
              <!-- /INSERT HERE -->

            </v-tab-item>
          </v-tabs-items>


        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue'
import VueGallery from 'vue-gallery'
import VueScrollTo from 'vue-scrollto'
export default {
  name: 'artistProfile',
  components: {
    'gallery': VueGallery
  },
  created () {
    this.initTabs()
    this.fetchArtist()
    VueScrollTo.scrollTo('#artist-page', 0, this.scrollOptions)
  },
  data () {
    return {
      msg: 'Welcome to Artist Profile',
      themeColor: (this.$store.state.config && this.$store.state.config.themeColor) || '#9E9E9E',
      enterpriseLogo: (typeof window.VividArts !== 'undefined' && window.VividArts.enterpriseLogo) || 'https://www.palmbeachculture.com/wp-content/uploads/cultural-council-palm-beach-county-logo-web@2x.png',
      enterpriseLogoContain: true,
      show: true,
      urid: parseInt(window.VividArts.urid),
      activeTab: 'tab-about',
      lightboxIndex: null,
      galleryLightboxIndex: null,
      scrollOptions: {
        el: '#artist-page',
        easing: 'ease-in',
        offset: -200,
        cancelable: true,
        onDone: function () {
          // scrolling is done
        },
        onCancel: function () {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      },
      hasTabs: [false, false, false, false],
      breadcrumbs: [],

      artistArtworkImages: [],
      artistArtworks: [],
      enterprise: {},
      artist: {},
      enableEditArtistLink: false,
      placeHolderArtistImg: this.$store.state.placeholderArtistImg,

      mapCenter: { lat: 26.71348, lng: -80.0580457 },
      artworkMarkers: [],
      bounds: null,
      infoContent: '',
      infoImage: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      // optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      tabs: [
        // {
        //   name: 'artworks',
        //   icon: 'brush'
        // },
        // {
        //   name: 'about',
        //   icon: 'info_outline'
        // }
        // {
        //   name: 'store',
        //   icon: 'store'
        // }
      ],
      items: [
        { active: true, title: 'Followers' },
        { active: true, title: 'Following' },
        { title: 'Artworks' }
      ],
      shareMenu: [
        { title: 'Facebook' },
        { title: 'Instagram' },
        { title: 'Twitter' },
        { title: 'Email' }
      ]
    }
  },
  watch: { },
  computed: {
    // artist () {
    //   var key = this.$route.params.id
    //   var a = this.artists.filter(function (item) {
    //     return item['.key'] === key
    //   })
    //   if (a.length > 0) {
    //     return a[0]
    //   }
    //   return null
    // },
    shouldIncludeCVTab () {
      console.log('shouldIncludeCVTab')
      var at = this.tabs.filter(function (item) {
        return item.name === 'cv'
      })

      if (typeof this.artist === 'undefined' || at.length > 0) {
        return false
      }

      if (typeof this.artist.exhibitions !== 'undefined' && this.artist.exhibitions.length) {
        this.addCVTab()
        return true
      }

      if (typeof this.artist.podcasts !== 'undefined' && this.artist.podcasts.length) {
        this.addCVTab()
        return true
      }

      if (typeof this.artist.videos !== 'undefined' && this.artist.videos.length) {
        this.addCVTab()
        return true
      }

      if (typeof this.artist.printBlogs !== 'undefined' && this.artist.printBlogs.length) {
        this.addCVTab()
        return true
      }

      return false
    }
    // enterprise () {
    //   var eid = window.VividArts.enterpriseId
    //   if (typeof eid !== 'undefined') {
    //     var e = this.enterprises.filter(function (item) {
    //       return item['.key'] === eid
    //     })
    //     if (e.length > 0) {
    //       return e[0]
    //     } else {
    //       return null
    //     }
    //   }
    //   return null
    // },
    // artistArtworks () {
    //   var key = this.$route.params.id
    //   var a = this.artworks.filter(function (item) {
    //     if (typeof item.artists !== 'undefined') {
    //       return item.status === 'active' && item.artists.indexOf(key) >= 0 && item.cloudinaryImageURL
    //     }
    //     return false
    //   })
    //   // if (a.length > 0) {
    //   //   var vm = this
    //   //   setTimeout(function () {
    //   //     vm.initMap()
    //   //   }, 1)
    //   // }
    //   return a
    // },
    // artistArtworkImages () {
    //   return this.artistArtworks.map(function (item) {
    //     return item.cloudinaryImageURL
    //   })
    // }
  },
  methods: {
    initMap () {
      console.log('init map')
      this.bounds = new window.google.maps.LatLngBounds()
      var bounds = this.bounds
      this.artworkMarkers = this.artistArtworks
        .filter(function (item) {
          return typeof item.latitude !== 'undefined' && item.latitude !== '' && typeof item.longitude !== 'undefined' && item.longitude !== ''
        })
        .map(function (item) {
          bounds.extend({lat: parseFloat(item.latitude), lng: parseFloat(item.longitude)})
          return {
            position: {lat: parseFloat(item.latitude), lng: parseFloat(item.longitude)},
            icon: 'http://res.cloudinary.com/vividarts/image/upload/c_scale,w_30/v1506999888/poi-marker_hw5lin.png',
            infoText: item.name,
            infoImage: item.cloudinaryImageURL
          }
        })
      var fam = this.fitArtworkMarkers
      setTimeout(function () {
        fam()
      }, 500)
    },
    fitArtworkMarkers () {
      console.log('fitArtworkMarkers', this.$refs, this.bounds)
      if (typeof this.$refs.artworksMap !== 'undefined' && this.$refs.artworksMap.length) {
        this.$refs.artworksMap[0].$mapObject.fitBounds(this.bounds)
      }
    },
    fetchArtistRevisions () {
      console.log('fetch artists')
      var url = this.$store.state.apiURL + `/v2/artists/${this.$route.params.id}/revisions`
      // debugger

      this.axios.get(url, this.$store.state.axiosConfig).then((response) => {
        var data = response.data.revision
        console.log('API | artists revisons', data)
        // debugger
        if (!data) { return }
        var artistRevisions = Vue._.clone(data, false)

        this.artist = artistRevisions

        if (typeof this.artist.bio !== 'undefined') {
          this.artist.bio = unescape(this.artist.bio)
        }
        if (typeof this.artist.excerpt !== 'undefined') {
          this.artist.excerpt = unescape(this.artist.excerpt)
        }
        this.initTabs()
      })
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      this.infoImage = marker.infoImage

      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
    facebookURL () {
      return 'https://www.facebook.com/' + this.artist.facebook.replace('@', '')
    },
    instagramURL () {
      return 'https://www.instagram.com/' + this.artist.instagram.replace('@', '')
    },
    pinterestURL () {
      return 'https://www.pinterest.com/' + this.artist.pinterest
    },
    twitterURL () {
      return 'https://www.twitter.com/' + this.artist.twitter
    },
    websiteURL () {
      var url = ''
      if (this.artist.website.indexOf('http://') === -1 && this.artist.website.indexOf('https://') === -1) {
        url += 'http://'
      }
      url += this.artist.website
      return url
    },
    setBreadCrumbs () {
      this.breadcrumbs = []
      this.breadcrumbs.push(
        {
          text: 'All Artists',
          disabled: false,
          href: {name: 'ArtistsDirectory'}
        }
      )
      if (typeof this.artist === 'undefined') {
        return
      }
      if (typeof this.artist.firstName !== 'undefined') {
        this.breadcrumbs.push(
          {
            text: `${this.artist.firstName} ${this.artist.lastName}`,
            disabled: false
          }
        )
      } else {
        this.breadcrumbs.push(
          {
            text: `${this.artist.permalink}`,
            disabled: false
          }
        )
      }
    },
    fetchArtist () {
      console.log('fetch artists')
      if (typeof this.$route.query !== 'undefined' && typeof this.$route.query.preview !== 'undefined' && parseInt(this.$route.query.preview) === 1) {
        this.fetchArtistRevisions()
        return
      }
      var requestUrl = this.$store.state.apiURL + '/v2/artists/' + this.$route.params.id
      var vm = this
      this.axios.get(requestUrl, this.$store.state.axiosConfig).then((response) => {
        var data = response.data.artist
        // console.log('API | artists', data)
        if (data === null || typeof data === 'undefined') { return }

        vm.artist = Vue._.clone(data, false)
        if (typeof vm.artist.bio !== 'undefined') {
          vm.artist.bio = unescape(vm.artist.bio)
        }
        if (typeof vm.artist.bioHTML !== 'undefined') {
          vm.artist.bioHTML = unescape(vm.artist.bioHTML)
        }
        if (typeof vm.artist.excerpt !== 'undefined') {
          vm.artist.excerpt = unescape(vm.artist.excerpt)
        }
        vm.initTabs()
        vm.setBreadCrumbs()
        VueScrollTo.scrollTo('#artist-page', 0, this.scrollOptions)
        console.log('VueScrollTo')
      })
    },
    initTabs () {
      // console.log(this.artist.gallery)
      this.setBreadCrumbs()
      if (typeof this.artistArtworks !== 'undefined' && this.artistArtworks.length) {
        var hasItem1 = this.tabs.filter(function (item) {
          return item.name === 'artworks'
        })
        if (hasItem1.length === 0) {
          this.tabs.push({
            name: 'artworks',
            icon: 'brush'
          })
        }
      }

      // if (typeof this.artist.bio !== 'undefined' && this.artist.bio !== '') {
      var hasItem2 = this.tabs.filter(function (item) {
        return item.name === 'about'
      })
      if (hasItem2.length === 0) {
        this.tabs.push({
          name: 'about',
          icon: 'info_outline'
        })
        this.hasTabs[0] = true
      }
      // }

      if (typeof this.artist.gallery !== 'undefined' && this.artist.gallery.length) {
        var hasItem3 = this.tabs.filter(function (item) {
          return item.name === 'gallery'
        })
        if (hasItem3.length === 0) {
          this.tabs.push({
            name: 'gallery',
            icon: 'photo_library'
          })
          this.hasTabs[2] = true
        }
      }

      if (this.tabs.length > 0) {
        this.activeTab = 'tab-' + this.tabs[0].name
        console.log('activeTab -->', this.activeTab)
      }

      if (this.$store.getters.getUser !== null && (['admin', 'enterprise'].indexOf(this.$store.getters.getUser.type) >= 0 || (this.$store.getters.getUser.type === 'artist' && this.$store.getters.getUser.permalink === this.$route.params.id))) {
        this.enableEditArtistLink = true
      }
    },
    addCVTab () {
      this.tabs.push({
        name: 'cv',
        icon: 'info_outline'
      })
      this.hasTabs[3] = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.profile-overview .social-menu li{
  overflow: hidden;
  padding-bottom: 8px;
}
.profile-overview .social-menu li a{
  width: 100%;
  overflow: hidden;
  display: inline-block;
  word-break: break-all;
  text-align: right;
  padding-right: 16px;
}
.profile-overview .social-menu li .list__tile__content{
  width: 40px;
  display: inline-table;
}
.profile-overview .breadcrumbs-wrap .breadcrumbs li:first-child a{
  padding-left: 0;
}
.profile-overview .breadcrumbs-wrap .breadcrumbs,
.profile-body .breadcrumbs-wrap .breadcrumbs{
  float: left;
  text-align: left;
}
.profile-overview .breadcrumbs-wrap .breadcrumbs li:last-child a,
.profile-body .breadcrumbs-wrap .breadcrumbs li:last-child a {
  color: rgb(0, 0, 0);
}
.profile-body .breadcrumbs-wrap .breadcrumbs li:last-child a {
  font-size: 1em;
}
</style>
<style scoped>
.profile-overview .social-menu .list__tile__action{
  word-wrap: break-word;
  padding-right: 40px;
  text-align: right;
  display: inline-table;
}
.profile-overview .social-menu .list__tile{
  height: auto;
}
.profile-overview .social-menu .list__tile__action a{
  white-space: normal;
  word-wrap: break-word;
  overflow: hidden;
  height: auto;
}
.background-header{
  width: 100%;
  height: 300px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  /* background-color: rgb(88, 38, 88); */
  background-size: cover;
  background-position: center center;
}

.artist-profile-content{
  padding-top: 150px;
  position: relative;
  z-index: 10;
}
.artist-profile-content .profile-overview .content{

}
.btn.follow-artist{
  margin-top: -71px;
}


.artwork-info-window{
  position: relative;
}
.artwork-info-window .img-wrap{
  position: relative;
  width: 100%;
  height: 90px;
}
.artwork-info-window .img-wrap .artwork-img{
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 90px;
  background-size: cover;
}
.artwork-info-window p{

}

.artist-profile-content .profile-body{
  margin-top: 50px
}
.artist-profile-content .profile-body .content{
  background: rgba(255,255,255,0.9);
}
.artist-profile-content .profile-body .share-profile{
  width: 90%;
  margin-top: 25px;
}
.text-content{
  white-space: pre-line;
  font-size: 1.3em;
}
.text-content.empty p{
  background-color: rgb(210, 211, 213);
  height: 20px;
}
#cv.tabs__content .cv-content .list{
  width: 100%;
}
#cv.tabs__content .cv-content .list .list__tile__title{
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// ArtistProfile.vue?5dc912a1